// src/components/Others/NavBar.js
import NavBar from '../NavBar';
import Footer from '../Footer';
import React from 'react';

const DMCA = () => {
	return (
<div>

<NavBar />
		
<div className="privacy">
		<h1>DMCA Notice</h1>
		<p>
		<b>NOTE: We do not host, store, or transmit any movies, TV shows, or other media files on our own infrastructure. The service helps you discover and access content through third‑party sources. We do not control those sources or their content.</b>
		<br /><br />
		<br /><br /> Defilms uses <strong> The Movie Database (TMDB)</strong> as a source of movie and TV show metadata, including titles, descriptions, posters, backdrops, release information, genres, ratings, and other related information. TMDB is used solely to provide information and improve the discovery experience on Defilms.
		<br /><br />
		In compliance with the Digital Millennium Copyright Act of 1998 (DMCA) (accessible on the U.S. Copyright Office website at http://lcweb.loc.gov/copyright/), Defilms will promptly address claims of copyright infringement that are reported to Defilms&rsquo;s designated copyright agent specified below. It is important to note that Section 512(f) of the DMCA holds individuals accountable for knowingly misrepresenting that material or activity is infringing, potentially resulting in legal liability. Defilms reserves the right, at its sole discretion, to remove content and terminate the accounts of users who engage in, or appear to engage in, the unauthorized use of intellectual property or other rights belonging to third parties.
<br /><br />
If you believe that your copyrighted work has been copied in a manner that constitutes copyright infringement, please provide Defilms&rsquo;s copyright agent with the following information:
<br /><br />
1. A physical or electronic signature of a person authorized to act on behalf of the copyright owner whose rights have allegedly been infringed.
<br /><br />
2. Identification of the copyrighted work claimed to have been infringed, or if multiple copyrighted works on a single online site are involved, a representative list of such works at the website.
<br /><br />
3. Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled. Please provide sufficient information to enable Defilms to locate the material.
<br /><br />
4. Information reasonably sufficient to allow Defilms to contact the complaining party, including a name, address, telephone number, and, if available, an email address.
<br /><br />
5. A statement that the complaining party has a good-faith belief that the use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.
<br /><br />
6. A statement that the information in the notification is accurate and, under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of the exclusive right that is allegedly infringed.
<br /><br />
All claims of copyright infringement related to this website should be addressed to Defilms&rsquo;s designated copyright agent at the following address:
<br /><br />
Copyright Contact Information:
Please contact us at admin@defilms.online. Kindly include &rsquo;DMCA&rsquo; in the subject line of your email.
<br /><br />
We sincerely apologize for any misuse of our service and assure you that we are committed to promptly identifying and terminating any abusive files.
<br /><br />
<b>NOTE: We do not host, store, or transmit any movies, TV shows, or other media files on our own infrastructure. The service helps you discover and access content through third‑party sources. We do not control those sources or their content.</b>
		</p>
	</div>

	<Footer />
</div>

	);
  };

export default DMCA;
